/* eslint-disable no-param-reassign */
import produce from 'immer';
import { AuthenticationActions } from 'react-aad-msal';

const initialState = {
  user: null
};

const accountReducer = (state = initialState, action) => {
  switch (action.type) {
    case AuthenticationActions.LoginSuccess: {
      const { account } = action.payload;
      return produce(state, (draft) => {
        draft.user = account;
      });
    }

    default: {
      return state;
    }
  }
};

export default accountReducer;
